<template>
 
<form v-if="my_item" @submit.prevent="save">
 <!--------row------------>
        <div class="row">
<div class="col-8">
             <PrimeBreadcrumb
    :home="home"
    :model="items"
    style="margin-top: 0px"
  ></PrimeBreadcrumb>
          </div>


          <div class="col-2">
            <PrimeButton
              label="Cancel"
              icon="pi pi-times"
              class="p-button-secondary"
              @click="closeModal()"
            />
          </div>
          <div class="col-2">
            <PrimeButton
              type="submit"
              label="Save"
              icon="pi pi-check"
              class="p-button-primary"
            />
          </div>
        </div>



  
     
        <div class="row">

<div class="col-3">
            <my-date-single
              v-model="my_item.awB_Date"
              :label="'提單日期'"
               :disabled="true"
            ></my-date-single>
          </div>


          <div class="col-2">
             <my-text-single
              v-model="my_item.awB_No"
              :label="'提單號碼'"
               :disabled="true"
            ></my-text-single>
          </div>
           
         </div> <!--------row------------>

         <div class="row">


          <div class="col-3">
            <my-text-single
              v-model="my_item.rec_Short_Name"
              :label="'收貨人'"
               :disabled="true"
            ></my-text-single>
          </div>

          <div class="col-3">
            <my-text-single
              v-model="my_item.rec_Phone"
              :label="'收客電話'"
               :disabled="true"
            ></my-text-single>
          </div>

          <div class="col-3">
            <my-text-single
              v-model="my_item.rec_Contact"
              :label="'聯絡人'"
               :disabled="true"
            ></my-text-single>
          </div>

         </div> <!--------row------------>
         <div class="row">
          <div class="col-12">
            <my-text-single
              v-model="my_item.rec_Address"
              :label="'收客地址'"
               :disabled="true"
            ></my-text-single>
          </div>
        </div> <!--------row------------>
         






            <div class="row">
           
          
          <div class="col-3">
            <my-text-single
              v-model="my_item.transfer_AWB_No"
              :label="'轉單號碼'"
               :disabled="true"
            ></my-text-single>
          </div>

          <div class="col-3">
            <my-text-single
              v-model="my_item.arrival_Income"
              :label="'到付應收'"
               :disabled="true"
            ></my-text-single>
          </div>
          
           
       </div>






        <!--------row------------>

      
      
    <div class="row">
          <div class="col-9">
            <my-text-single
              v-model="my_item.note"
              :label="'備註'"
                :disabled="true"
            ></my-text-single>
          </div>
          <div class="col-3">
            <my-text-single
              v-model="my_item.sign_Man"
              :label="'簽收人'"
              :required="false"
            ></my-text-single>
          </div>
        </div>

 


      
<!-- 

<PrimeTabView :activeIndex="activeIndex">
 


   
<PrimeTabPanel header="貨況資訊">
<ul>
  <template v-for="(cargo,index) in my_item.exp_Cargo_Status"  :key="index" >
    <li> {{format_date_yyyymmddHHmm(cargo.updatetime)}} : {{cargo.status}}/{{cargo.status_E}} </li>
  </template>
</ul>
</PrimeTabPanel>
<PrimeTabPanel header="子提單資訊">
<table class="table  table-bordered">
  <tr>
    <th>子提單號</th>
    <th>清關條碼</th>
    <th>預計件數</th>
    <th>計費重量</th>
    <th>實際品名</th>
   
  </tr>
  <tr v-for="(detail,index) in my_item.imp_AWB_Detail"  :key="index" >
    <td>      {{detail.subAWBNo}}    </td>
    <td>      {{detail.preClearanceCustomsBarCode}}    </td>
    <td>      {{detail.prePiece}}    </td>
    <td>      {{detail.cost_Weight}}    </td>
    <td>      {{detail.actual_Goods_Name}}    </td>
     
  </tr>
</table>
</PrimeTabPanel>


</PrimeTabView> -->

 

<hr/>




         
  </form>
</template>


<script>
import service from "../service/Appservice";

export default {
  props: ["iden"],
  data() {
    return {
      my_item: null,
      activeIndex:0,
      home: { icon: "pi pi-home", to: "/" },
      items: [{ label: "出口提單" }, { label: "出口提單維護" }],
      file: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    agentNo() {
      return this.$store.state.user?.agentNo;
    },
    agentName() {
      return this.$store.state.user?.agentName;
    },
    companyNo() {
      return this.$store.state.user?.companyNo;
    },
  },
  service: null,
  created() {
    //this.my_item = this.item ;
    //console.log('created')
    //console.log(this.my_item)
    this.service = new service();
  },
  mounted() {
    this.search();
  },
  methods: {

format_date_yyyymmddHHmm(mdate){
    const date=new Date(mdate)
    const Year = date.getFullYear();
    const Month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    const Day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();

   // let Format_string = "";
    //Format_string = Year + "/" + Month + "/" + Day;

    let hh = date.getHours();
    let mf = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
   // let ss = date.getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
    let Format_string =  Year + "/" + Month + "/" + Day + " " + hh + ":" + mf ;


    return Format_string;
  },
 




    select(event) {
      this.file = event.files[0]
      console.log(event.files[0]);
      this.my_item.sign_FileName = event.files[0].name;
    },

    ////////搜尋/////////////////////////////////////
    search() {
      this.service.getExpAWBItem(this.iden).then((data) => {
        console.log(data);
        this.my_item = data;
        if(this.my_item.awB_Date){
          this.my_item.awB_Date = new Date(this.my_item.awB_Date)
       }
        if(this.my_item.arrival_Date){
          this.my_item.arrival_Date = new Date(this.my_item.arrival_Date)
       }
        if(this.my_item.arrival_Date_Real){
          this.my_item.arrival_Date_Real = new Date(this.my_item.arrival_Date_Real)
       }

 

      this.my_item.exp_Cargo_Status = this.my_item.exp_Cargo_Status.sort(function (a, b) {
      return a.updatetime < b.updatetime ? 1 : -1;
      });




        console.log(this.my_item);
      });
    },

    closeModal() {
      this.$emit("close");
    },
    save() {
      var self = this;
       let serialisedJson = JSON.stringify(this.my_item);
        let formData = new FormData();
        formData.append('initializationData', serialisedJson);
        if (this.file) {
            // the 'jsonFile' name might cause some confusion:
            // in this case, the uploaded file is actually a textfile containing json data
            formData.append('jsonFile', this.file);
        }

      this.service.updateExpAWBItem(formData).then((data) => {
        console.log(data)
        self.$emit("save", self.my_item);
        self.$emit("itemsavedone", self.my_item);
      });
    },
  },
};
</script>